//#region src/locales/en/common.json
var e = {
	cancel: "Cancel",
	cancelled: "Upload of {{name}} was cancelled",
	confirm: "Confirm",
	confirm_action: "Confirm action",
	created_at: "Created at",
	delete: "Delete",
	done: "Done",
	download: "Download",
	error: "Error",
	errors: {
		conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!",
		fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue",
		internal_error_message: "Something went wrong. Please try again",
		payload_to_large_error_message: "The file size is too big"
	},
	file: "File",
	file_deleted_successfully: "Deleted successfully",
	file_details: "File details",
	file_renamed_successfully: "Renamed successfully",
	file_selector: {
		choose_file: "Choose a file",
		enter_new_file_name: "Enter a new file name",
		failed_delete_file: "Failed to delete file",
		failed_download_file: "Failed to download file",
		failed_rename_file: "Failed to rename file",
		file_deletion_confirmation_text: "Are you sure you want to delete \"{{file}}\"?",
		file_name: "File name",
		files_selected: "file selected",
		rename_file: "Rename file",
		search_file: "Search file"
	},
	file_source: {
		block_preview: "Block preview",
		blog_post: "Blog post",
		blog_template_preview: "Blog template preview",
		calendar_host_avatar: "Calendar",
		ckeditor: "CKEditor",
		community: "Community",
		digital_product_resource: "Digital product resource",
		digital_store: "Link in bio",
		editor: "Editor",
		email: "Email",
		email_template: "Email template",
		file_manager: "File manager",
		funnel_template_preview: "Funnel template preview",
		marketplace: "Marketplace",
		membership: "Membership",
		page_template: "Page template",
		page_template_preview: "Page template preview",
		product: "Product",
		settings: "Settings",
		text_editor: "Text editor",
		website_template: "Website template",
		white_label: "White Label"
	},
	file_type: {
		audio: "Audio",
		document: "Document",
		font: "Font",
		image: "Image",
		image_other: "Other image",
		video: "Video"
	},
	file_upload: {
		accepts_jpg_png_files: "Accepts .jpg and .png",
		crop_and_select_file: "Crop and select an image",
		crop_file: "Crop image ",
		drag_files: "Drag files or <span>click to browse</span>",
		drop_files_here: "Drag and drop your files here, or click to browse",
		duplicates_skipped: "{count, plural,\n  one {{count} duplicate file skipped}\n  other {{count} duplicate files skipped}\n}",
		file_not_supported: "File type not supported",
		files_uploaded: "{{count}} of {{totalCount}} uploaded",
		upload_and_select_file: "Upload and select",
		upload_files: "Upload files",
		upload_incomplete_error: "{totalFailed, plural, \n    one {{totalFailed} of {totalFiles} file failed to upload} \n    other {{totalFailed} of {totalFiles} files failed to upload}\n}",
		uploaded_successfully: "Successfully uploaded"
	},
	image_cropper: {
		aspect_ratio: {
			need_to_crop: "Crop image before selecting",
			need_to_crop_note: "The image {{name}} has a different aspect ratio. Please crop it to match the required one"
		},
		rounded_crop: "Circle",
		square_crop: "Square"
	},
	name: "Name",
	preview: "Preview",
	processing_size: "Processing",
	rename: "Rename",
	search: "Search",
	select: "Select",
	select_source: "Select source",
	select_type: "Select file type",
	size: "Size",
	something_went_wrong: "Something went wrong",
	title: "File Manager",
	type: "Type",
	upload: "Upload"
}, t = { file_manager: e };
//#endregion
export { t as default, e as file_manager };
